import {
  Show,
  SimpleShowLayout,
  TextField,
  BooleanField,
  DateField,
  ArrayField,
  SingleFieldList,
  ChipField
} from 'react-admin';

const EnterpriseAdminShow = () => (
  <Show
    title="Usuário Admin Empresa">
    <SimpleShowLayout>
      <TextField source="id"/>
      <TextField source="enterprise_name" label="Empresa" />
      <TextField source="name" label="Nome" />
      <TextField source="email" label="E-mail" />
      <BooleanField source="is_master" label="Master" />
      <BooleanField source="active" label="Ativo" />
      <ArrayField label="Permissões" source="permissions" fieldKey="uuid">
        <SingleFieldList
          linkType={false}>
          <ChipField source="name" />
        </SingleFieldList>
      </ArrayField>
      <DateField source="created_at" locales="pt-BR" label="Criado em" showTime />
    </SimpleShowLayout>
  </Show>
);

export default EnterpriseAdminShow;
